import {Component} from 'react';
import { doubleToStringMonthly } from '../../../objects/CommonUse/double_functions';


class InvestmentPortfolioDisplayCard extends Component {
    constructor(props) {
        super(props);
        this.state = {open: false, 
             selected: false,
        };
        
    }

    determineGainLossInfo(){
        this.gainLossClass = "text-right";
        if (this.props.portfolioInfo.totalGainLoss < 0){
            this.gainLossClass += " text-danger";
        }
        if (this.props.displayPercent === true){
        if (this.props.portfolioInfo.totalInitialValue &&
                this.props.portfolioInfo.totalGainLoss &&
                this.props.portfolioInfo.totalInitialValue !== 0){
                this.gainLossPercent = 
                    (this.props.portfolioInfo.totalGainLoss / this.props.portfolioInfo.totalInitialValue
                        * 100).toFixed(2) + "%";
            }
        }else{
            this.gainLossPercent = "";
        }
    }
    
    

    render() {
        this.determineGainLossInfo();
    return <>
        <tr>
            <th className="text-left">{this.props.portfolioInfo.investType}</th>
            {+this.props.portfolioInfo.totalInitialValue  ?
                 <td className="text-right">
                    {doubleToStringMonthly(this.props.portfolioInfo.totalInitialValue)}</td>
            :
                <td className = "text-right">{this.props.portfolioInfo.totalInitialValue}</td>
            }
            {+this.props.portfolioInfo.totalCurrentValue  ?
                  <td className="text-right">
                    {doubleToStringMonthly(this.props.portfolioInfo.totalCurrentValue)}</td>
            :
                <td className = "text-right">{this.props.portfolioInfo.totalCurrentValue}</td>              
            }
            <td className={this.gainLossClass}>{doubleToStringMonthly(this.props.portfolioInfo.totalGainLoss)}</td>
            <td className="text-right">{this.gainLossPercent}</td>
            </tr>
          
    </>
    }



}

export default InvestmentPortfolioDisplayCard;